import type { LazyQueryExecFunction } from '@apollo/client';
import { useLazyQuery } from '@apollo/client';

import type { UserJobApplicationCv } from '@xing-com/crate-common-graphql-types';
import type { GetUserRecentCvsQuery } from '@xing-com/crate-jobs-graphql';
import { GetUserRecentCvsDocument } from '@xing-com/crate-jobs-graphql';

import { getSortedCvs } from './util';

type UseGetUserRecentCvsReturnValue = {
  getUserRecentCvs: LazyQueryExecFunction<
    GetUserRecentCvsQuery,
    { [key: string]: never }
  >;
  hasError: boolean;
  isLoading: boolean;
  userRecentCvs: UserJobApplicationCv[];
};

export const useLazyGetUserRecentCvs = (): UseGetUserRecentCvsReturnValue => {
  const [getUserRecentCvs, { data, error, loading }] = useLazyQuery(
    GetUserRecentCvsDocument,
    {
      fetchPolicy: 'network-only',
    }
  );

  return {
    getUserRecentCvs,
    hasError: !!error || !data?.viewer?.userRecentCvs,
    isLoading: loading,
    userRecentCvs: getSortedCvs(data?.viewer?.userRecentCvs),
  };
};
